import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

const GetCargoCompanies = () =>
    request({
        url: ApiURL.Query.GetLostCargoCompanies,
        method: RequestType.GET,
    });

const GetInvoicePDF = (params: any) =>
    request({
        url: ApiURL.Query.GetInvoicePDF,
        method: RequestType.GET,
        params,
    });

const LostCargoQuery = {
    GetCargoCompanies,
    GetInvoicePDF,
};

export default LostCargoQuery;
